import { Component } from '@angular/core';

import { of } from 'rxjs';

import { DropdownComponent, InputChoicesComponent, RadioComponent, SwitchComponent } from '@camelot/form-input';
import { InputChoices, InputDropdown, InputRadio, InputSwitch } from '@camelot/form-model';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [DropdownComponent, InputChoicesComponent, RadioComponent, SwitchComponent, TestIdDirective],
    template: `
    <cam-input-dropdown camTestId="cam-input-dropdown" [input]="this.dropdown" [standalone]="true" />
    <cam-input-radio camTestId="cam-input-radio" [input]="this.radio" [standalone]="true" />
    <cam-input-switch camTestId="cam-input-switch" [input]="this.switch" [standalone]="true" />
    <cam-input-choices camTestId="cam-input-choices" [input]="this.choices" [standalone]="true" />
  `
})
export class FormInputsSelectCase {
  public choices = new InputChoices({
    key: 'choices',
    label: 'Choices',
    options: of([
      { data: null, id: '1', name: 'One' },
      { data: null, id: '2', name: 'Two' },
    ]),
  });
  public dropdown = new InputDropdown<string>({
    key: 'dropdown',
    label: 'Dropdown',
    options: of([
      { id: '1', name: 'One' },
      { id: '2', name: 'Two' },
    ]),
  });
  public radio = new InputRadio<string>({
    key: 'radio',
    label: 'Radio',
    options: of([
      { id: '1', name: 'One' },
      { id: '2', name: 'Two' },
    ]),
  });
  public switch = new InputSwitch({
    key: 'switch',
    label: 'Switch',
    match: of({ prop: {}, type: 'textbox' as const }),
  });
}
